import { render, staticRenderFns } from "./CommittedShow.vue?vue&type=template&id=6a6ad2c1&"
import script from "./CommittedShow.vue?vue&type=script&lang=js&"
export * from "./CommittedShow.vue?vue&type=script&lang=js&"
import style0 from "./CommittedShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports